module.exports = __webpack_public_path__ + "img/4.f724cf76.png";